// Mask GSTIN - Show first 2 and last 3 characters
export const maskGSTIN = (gstin) => {
    if (gstin && gstin.length >= 5) {
      return gstin.slice(0, 2) + '*'.repeat(gstin.length - 5) + gstin.slice(-3);
    }
    return gstin;
  };
  
  // Mask PAN - Show first 2 and last 2 characters
  export const maskPAN = (pan) => {
    if (pan && pan.length >= 4) {
      return pan.slice(0, 2) + '*'.repeat(pan.length - 4) + pan.slice(-2);
    }
    return pan;
  };
  
  // Mask Account Number - Show only the last 4 digits
  export const maskAccountNumber = (accountNumber) => {
    if (accountNumber && accountNumber.length >= 4) {
      return '*'.repeat(accountNumber.length - 4) + accountNumber.slice(-4);
    }
    return accountNumber;
  };
  
  // Mask Confirm Account Number – Show all *
  export const maskConfirmAccountNumber = (confirmAccountNumber) => {
    if (confirmAccountNumber) {
      return '*'.repeat(confirmAccountNumber.length);
    }
    return confirmAccountNumber;
  };
  